import { Trans } from "@lingui/react/macro";
import { Alert } from "@warp-ds/elements/react/alert";

export const InactiveAlert = () => {
  return (
    <Alert className="mt-24" variant="negative" show>
      <h3 className="t4 -mt-2">
        <Trans id="itemPageLayout.adinfo.inactive.title">This ad is no longer available</Trans>
      </h3>
      <p>
        <Trans id="itemPageLayout.adinfo.inactive.cannotcontact">
          The seller can’t be contacted about this vehicle.
        </Trans>
      </p>
    </Alert>
  );
};
